import apiClient from "../../apis/ApiInterceptor";
import { getSignature } from "../../apis/wompiApi";
import { openNotification } from "../../components/notifications";
import { jwtDecode } from "jwt-decode";
import PayTypes from "../../enums/pay_types";


export const loadWompiScript = () => {
    return new Promise((resolve, reject) => {
        if (window.WidgetCheckout) {
            resolve(); // Already loaded
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://checkout.wompi.co/widget.js';
        script.type = 'text/javascript';
        script.async = true;

        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Wompi script'));

        document.body.appendChild(script);
    });
};

export const showPayModal = async ({
    plan,
    paymentOption,
    setLoading,
}) => {
    if (!window.WidgetCheckout) {
        throw new Error('Wompi WidgetCheckout is not loaded');
    }

    const checkoutOptions = { publicKey: process.env.REACT_APP_WOMPI_PUBLIC_KEY };
    const currency = "COP" // TODO get from session

    if (paymentOption === 'automatic') {
        checkoutOptions.widgetOperation = 'tokenize';
    } else { // single payment
        const access_token = localStorage.getItem('access_token');
        const decodedToken = jwtDecode(access_token);
        const loggedUserId = decodedToken.sub;
        const amountInCents = (plan.promo_id && plan.for_unique_pay) ? 
            plan.promo_price_in_cents 
            : plan.price_in_cents;
        const response = await getSignature(loggedUserId, amountInCents, currency, PayTypes.PLAN, plan.plan_id);
        if (!response.success) {
            openNotification(
                'error',
                'Error con la pasarela de pagos',
                'Contacta a soporte si el problema persiste',
            );
            console.error('Error getting signature:', response.error);
            return;
        }
        checkoutOptions.widgetOperation = 'purchase';
        checkoutOptions.currency = currency;
        checkoutOptions.amountInCents = amountInCents
        checkoutOptions.reference = response.data.reference;
        checkoutOptions.signature = { integrity: response.data.signature };
    }

    const checkout = new window.WidgetCheckout(checkoutOptions);

    checkout.open(async (result) => {
        if (paymentOption === 'automatic') {
            const token = result?.payment_source?.token;
            setLoading(true)
            const promoAmountInCents = (plan.promo_id && plan.for_automatic_debit) ? plan.promo_automatic_debt_price_in_cents : 0
            const response = await createSubscription(token, plan.automatic_debt_price_in_cents, promoAmountInCents, currency, plan.plan_id);
            setLoading(false)
            if (response.success) {
                openNotification(
                    'success',
                    'Subscripción creada con éxito',
                );
            } else {
                openNotification(
                    'error',
                    'Error creando la subscripción',
                    'Contacta a soporte si el problema persiste',
                );
                console.error('Error creating subscription:', response.error);
            }
        }
    });
};

const createSubscription = async (token, amountInCents, promoAmountInCents, currency, planId) => {
    try{
        const params = {
            token: token,
            amountInCents: amountInCents,
            promoAmountInCents: promoAmountInCents,
            currency: currency,
            planId: planId,
        };
        const response = await apiClient.post('/payments/subscriptions', params);
        return { success: true, data: response.data };
    } catch (error) {
        console.error('Wompi - createSubscriptio, Error creating subscription:', error);
        return { success: false, error };
    }
}
